"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CurrencySqliteHandler", {
    enumerable: true,
    get: function() {
        return CurrencySqliteHandler;
    }
});
const _decimalsqlitehandler = require("../decimal/decimal.sqlite.handler");
const _currencygeneralhandler = require("./currency.general.handler");
let CurrencySqliteHandler = class CurrencySqliteHandler extends _decimalsqlitehandler.DecimalSqliteHandler {
    constructor(...args){
        super(...args), this.currencyGeneralHandler = new _currencygeneralhandler.CurrencyGeneralHandler(), this.parseUserInput = this.currencyGeneralHandler.parseUserInput;
    }
};
